import React from 'react';
import { Link } from 'react-router-dom';

type CardTitleLinkProps = {
  to: string;
  children: React.ReactNode;
  disabled?: boolean;
};

// Wraps a card's title in a real <a href> so search engines can follow it and
// cmd/ctrl/shift-click opens a new tab. A plain click is left to the card's own
// onClick, which does the in-app navigation (and any Redux setup).
const CardTitleLink = ({ to, children, disabled }: CardTitleLinkProps) =>
  disabled ? (
    <>{children}</>
  ) : (
  <Link
    to={to}
    className="card-title-link"
    onClick={e => {
      if (e.metaKey || e.ctrlKey || e.shiftKey) e.stopPropagation();
      else e.preventDefault();
    }}
  >
    {children}
  </Link>
  );

export default CardTitleLink;
